import leaflet from "./leaflet/leaflet-loader";

leaflet();
